module.exports = __webpack_public_path__ + "static/Poppins-Medium-2d9db5c9b67bce30464c0c4d0d840fef.woff2";